import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { BoxForm, FormControlDefault, MenuItemStyled, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { toast } from 'react-toastify';
import { createEntity, getEntity, reset, updateEntity } from './tire-model.reducer';

export const TireModelUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const hasSaved = useRef(false);

  const tireModelEntity = useAppSelector(state => state.tireModel.entity);
  const loading = useAppSelector(state => state.tireModel.loading);
  const updating = useAppSelector(state => state.tireModel.updating);
  const updateSuccess = useAppSelector(state => state.tireModel.updateSuccess);

  const [formData, setFormData] = useState({
    name: null,
    specification: null,
    groove: null,
    tireManufacturer: null,
  });

  useEffect(() => {
    if (!isNew && tireModelEntity) {
      setFormData({
        name: tireModelEntity.name,
        specification: tireModelEntity.specification,
        groove: tireModelEntity.groove,
        tireManufacturer: tireModelEntity.tireManufacturer,
      });
    }
  }, [tireModelEntity]);

  const handleClose = () => {
    props.history.push('/tire-model' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess && hasSaved.current) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...tireModelEntity,
      ...values,
    };

    hasSaved.current = true;

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!formData?.name) {
      return toast.error('Insira um nome (exemplo: M792 ECO)');
    }

    if (!formData?.specification) {
      return toast.error('Insira uma medida (exemplo: 295/80R22.5)');
    }

    if (!formData?.groove) {
      return toast.error('Insira um sulco (exemplo: 23.5)');
    }
    
    if (!formData?.tireManufacturer) {
      return toast.error('Selecione uma marca (exemplo: Bridgestone)');
    }

    saveEntity(formData);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <RegisterLayout>
          <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
            <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.tireModel'} />
            <Box>
              {loading ? (
                <Box>
                  <Typography>Loading...</Typography>
                </Box>
              ) : (
                <Box margin={'0 auto'} width={'100%'}>
                  <BoxForm onSubmit={handleSubmit}>
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.tireModel.name')}</TypographyForms>
                      <TextFieldForms
                        value={formData['name']}
                        id={'tire-model-name'}
                        data-cy={'name'}
                        name={'name'}
                        onChange={e => handleInputChange('name', e.target.value)}
                      />
                    </FormControlDefault>

                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.tireModel.specification')}</TypographyForms>
                      <TextFieldForms
                        value={formData['specification']}
                        id={'tire-model-specification'}
                        data-cy={'specification'}
                        name={'specification'}
                        onChange={e => handleInputChange('specification', e.target.value)}
                      />
                    </FormControlDefault>

                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.tireModel.groove')}</TypographyForms>
                      <TextFieldForms
                        value={formData['groove']}
                        id={'tire-model-groove'}
                        data-cy={'groove'}
                        name={'groove'}
                        onChange={e => {
                          const value = e.target.value;
                          if (/^\d*([,.]\d*)?$/.test(value)) {
                            const normalizedValue = value?.replace(',', '.');
                            handleInputChange('groove', normalizedValue);
                          }
                        }}
                        inputProps={{
                          inputMode: 'decimal',
                          pattern: '\\d*([,.]\\d*)?',
                        }}
                      />
                    </FormControlDefault>

                    <FormControlDefault>
                      <SelectPaginate
                        label={translate('fleetSenseApp.tireModel.tireManufacturer')}
                        apiUrl={'api/tire-manufacturers'}
                        onChange={value => handleInputChange('tireManufacturer', value)}
                        value={formData['tireManufacturer']}
                        valueName="name"
                        icon="sort-down"
                        statusFilter
                        filterStyle={true}
                        searchName="brandSearch"
                        displayFormat={option => `${option.name ?? ''} ${option.type ? `(${option.type})` : ''}`}
                      />
                    </FormControlDefault>

                    <RegisterButton />
                  </BoxForm>
                </Box>
              )}
            </Box>
          </Box>
        </RegisterLayout>
      </ThemeProvider>
    </>
  );
};

export default TireModelUpdate;
